import React, { createElement } from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import './index.css';
// Set document title
document.title = 'YOGA ESENCIAL';
// Meta Pixel initialization
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
// Create and inject the Meta Pixel script
const initMetaPixel = () => {
  // Initialize fbq function
  if (!window.fbq) {
    const fbq = function (...args: any[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args);
      } else {
        fbq.queue.push(args);
      }
    } as any;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [] as any[];
    window.fbq = fbq;
    window._fbq = fbq;
  }
  // Load the Facebook pixel script
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  script.onload = () => {
    // Initialize pixel after script loads
    window.fbq('init', '2810662569268212');
    window.fbq('track', 'PageView');
  };
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }
  // Also fire immediately in case script was cached
  if (window.fbq && window.fbq.loaded) {
    window.fbq('init', '2810662569268212');
    window.fbq('track', 'PageView');
  }
};
// Initialize pixel
initMetaPixel();
// Add noscript fallback image
const noscriptImg = document.createElement('img');
noscriptImg.height = 1;
noscriptImg.width = 1;
noscriptImg.style.display = 'none';
noscriptImg.src = 'https://www.facebook.com/tr?id=2810662569268212&ev=PageView&noscript=1';
document.body.appendChild(noscriptImg);
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-194">
    <App data-id="element-195" />
  </React.StrictMode>);